import { render, staticRenderFns } from "./ProfitabilityCostsChartCard.vue?vue&type=template&id=50259b96&scoped=true"
import script from "./ProfitabilityCostsChartCard.vue?vue&type=script&lang=js"
export * from "./ProfitabilityCostsChartCard.vue?vue&type=script&lang=js"
import style0 from "./ProfitabilityCostsChartCard.vue?vue&type=style&index=0&id=50259b96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50259b96",
  null
  
)

export default component.exports